// extracted by mini-css-extract-plugin
export var boldText = "_5z-4";
export var checkboxContainer = "_5z-6";
export var closeIcon = "_5z-i";
export var container = "_5z-0";
export var drawer = "_5z-8";
export var drawerContent = "_5z-9";
export var extraSmallText = "_5z-5";
export var fulfillmentGroupTable = "_5z-e";
export var largeText = "_5z-3";
export var loadingSpinnerContainer = "_5z-j";
export var mediumText = "_5z-2";
export var narrow = "_5z-f";
export var notificationLink = "_5z-l";
export var packageCheckIconContainer = "_5z-7";
export var slideoutHeaderActions = "_5z-g";
export var slideoutHeaderActionsShifted = "_5z-h";
export var slideoutHeaderContainer = "_5z-a";
export var slideoutModal = "_5z-c";
export var stickyHeaderWrapper = "_5z-b";
export var table = "_5z-k";
export var tableContainer = "_5z-d";
export var tertiaryText = "_5z-1";